import Vue from 'vue';
import VueRouter from 'vue-router';
import Home from '../views/Home.vue';

Vue.use(VueRouter);

const rootPaths = [
  '/',
  '/focus',
  '/financials',
  '/leadership',
  '/about'
];

const routes = [
  {
    path: rootPaths[0],
    name: 'Annual Report Home',
    component: Home
  },
  {
    path: rootPaths[1],
    name: 'Focused on You',
    component: () => import('../views/Focus.vue'),
    subRoutes: [
      {
        name: 'Our Core Value',
        path: `${rootPaths[1]}#our-core-value`
      },
      {
        name: 'Listening to Members',
        path: `${rootPaths[1]}#listening-to-members`
      },
      {
        name: 'Building Resources',
        path: `${rootPaths[1]}#building-resources`
      },
      {
        name: 'What our Members are Saying',
        path: `${rootPaths[1]}#what-our-members-are-saying`
      }
    ]
  },
  {
    path: rootPaths[2],
    name: 'Financials',
    component: () => import('../views/Financials.vue'),
    subRoutes: [
      {
        name: 'Highlights',
        path: `${rootPaths[2]}#highlights`
      },
      {
        name: 'Balance Sheets',
        path: `${rootPaths[2]}#balance-sheets`
      },
      {
        name: 'Statements of Income',
        path: `${rootPaths[2]}#statements-of-income`
      },
      {
        name: 'Policyholders\' Surplus',
        path: `${rootPaths[2]}#policyholders-surplus`
      },
      {
        name: 'Cumulative Dividends',
        path: `${rootPaths[2]}#cumulative-dividends`
      },
      {
        name: 'Premiums Per Physician',
        path: `${rootPaths[2]}#premiums-per-physician`
      }
    ]
  },
  {
    path: rootPaths[3],
    name: 'Leadership',
    component: () => import('../views/Leadership.vue'),
    subRoutes: [
      {
        name: 'Board of Directors',
        path: `${rootPaths[3]}#board-of-directors`
      },
      {
        name: 'Officers',
        path: `${rootPaths[3]}#officers`
      },
      {
        name: 'Committees',
        path: `${rootPaths[3]}#committees`
      }
    ]
  },
  {
    path: rootPaths[4],
    name: 'About SVMIC',
    component: () => import('../views/About.vue')
  }
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: routes
});

export default router;
